var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { RequestSpaceCreateDataService } from './request-space-create-data.interface';
import { I18nService } from '@/services/i18n-service';
import { CreateSpaceService } from '@/domains/spaces/services/create-space-service.interface';
import { RavenService } from '@cores/modules/raven-module/raven-service';
import { RouterService } from '@cores/services/vue-router-service';
import { EditingSpaceModel } from '@/domains/editing-space/models/editing-space-model.interface';
let CreateSpaceContribution = class CreateSpaceContribution {
    constructor(_requestSpaceCreateDataService, _i18nService, _createSpaceService, _ravenService, _routerService, _editingSpaceModel) {
        this._requestSpaceCreateDataService = _requestSpaceCreateDataService;
        this._i18nService = _i18nService;
        this._createSpaceService = _createSpaceService;
        this._ravenService = _ravenService;
        this._routerService = _routerService;
        this._editingSpaceModel = _editingSpaceModel;
        this._requestSpaceCreateDataService.onAborted(() => { });
        this._requestSpaceCreateDataService.onReceived(this._onReceived.bind(this));
    }
    async _onReceived(data, next) {
        const result = await this._createSpaceService.createSpace(data);
        this._ravenService.track('Create Workspace', {
            other_param: data.spaceType,
        });
        next();
        this._routerService.push({
            name: 'detail',
            query: { spaceId: result.spaceId },
        });
        return result;
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'create-space',
        }, {
            execute: () => {
                this._ravenService.track('Click Add Workspace', {
                    page: 'Workspace',
                });
                return this._requestSpaceCreateDataService.request({
                    title: this._i18nService.t('workspace.labels.newWorkspace'),
                }).finally(() => {
                    this._editingSpaceModel.dispose();
                });
            },
        });
    }
};
CreateSpaceContribution = __decorate([
    injectable(),
    __param(0, inject(RequestSpaceCreateDataService)),
    __param(1, inject(I18nService)),
    __param(2, inject(CreateSpaceService)),
    __param(3, inject(RavenService)),
    __param(4, inject(RouterService)),
    __param(5, inject(EditingSpaceModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof RequestSpaceCreateDataService !== "undefined" && RequestSpaceCreateDataService) === "function" ? _a : Object, typeof (_b = typeof I18nService !== "undefined" && I18nService) === "function" ? _b : Object, typeof (_c = typeof CreateSpaceService !== "undefined" && CreateSpaceService) === "function" ? _c : Object, typeof (_d = typeof RavenService !== "undefined" && RavenService) === "function" ? _d : Object, typeof (_e = typeof RouterService !== "undefined" && RouterService) === "function" ? _e : Object, typeof (_f = typeof EditingSpaceModel !== "undefined" && EditingSpaceModel) === "function" ? _f : Object])
], CreateSpaceContribution);
export { CreateSpaceContribution };
